import { useRegistry } from './useRegistry'
import { useFeatureFlags } from './useFeatureFlags'

/**
 * The organisation an article's byline can be credited to, or an empty string
 * where that is not offered: the feature is off, or no organisation is named.
 */
export const useBylineOrganisation = (): string => {
  const { hasBylineCredit } = useFeatureFlags(['hasBylineCredit'])
  const { envs } = useRegistry()

  return hasBylineCredit ? envs.organisationName : ''
}
